import { Sort } from "@/components/_types/sort";

export const getCompanyContents = async (
	id: string,
	page?: string,
	sortObj?: Sort,
) => {
	const url = new URL(
		`${process.env.NEXT_PUBLIC_API_URL}/public/companies/contents`,
	);

	url.searchParams.append("companyId", id);

	if (page && /^[1-9]\d*$/.test(String(page))) {
		url.searchParams.append("page", String(Number(page) - 1));
	}

	if (sortObj) {
		url.searchParams.append("sortBy", sortObj?.sortBy);
		url.searchParams.append("direction", sortObj?.direction);
	}
	url.searchParams.append("size", "24");

	const res = await fetch(url.toString(), {
		method: "GET",
		headers: {
			"Content-Type": "application/json",
		},
		cache: "no-store",
	});

	if (!res.ok) throw new Error("Failed to fetch Item");
	return res.json();
};
